<template>
  <section class="user__profile current">
    <Loading
      v-if="isLoading"
      shape="circle"
      :stroke-width="8"
      :size="96"
      rotate
      :indeterminate="true"
    />
    <UserProfileCard
      v-else
      :user="userStandard"
      :heading="$t('headings.PROFILE_STANDARD')"
      :is-blocked="Object.keys(userIsBlockedGlobal).length > 0"
      :is-current-user="true"
      :alias="false"
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Loading from "../components/global/Loading";
import UserProfileCard from "../components/user-profile/UserProfileCard";

export default {
  name: "UserProfile",
  components: {
    Loading,
    UserProfileCard,
  },
  computed: {
    ...mapGetters(["isLoading", "myProfile", "myComments", "userIsBlockedGlobal"]),
    userStandard() {
      return {
        id: this.myProfile.userId,
        firstName: this.myProfile.firstName,
        lastName: this.myProfile.lastName,
        alias: false,
        picture: this.myProfile.profilePicture,
        rotation: this.myProfile.imageRotation,
        description: this.myProfile.description,
        date: this.myProfile.createdAt,
        comments: this.myProfile.numComments,
        removed: this.myProfile.numRemoved,
      };
    },
  },
};
</script>
